module.exports = __webpack_public_path__ + "img/Flag_of_Benin (1).203c8d48.svg";